import { ObjectMapper } from "json-object-mapper";
import { InsightModel } from "./insight.model";

export class InsightAbsenteismModel extends InsightModel {
  static create(input: any): InsightAbsenteismModel {
    return ObjectMapper.deserialize<InsightAbsenteismModel>(InsightAbsenteismModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}